import { API_BETA, jsonHeadersWithToken } from '@/lib/constants'

const PRICING_IFRAME_URL = import.meta.env.VITE_PRICING_IFRAME_URL || 'https://nocode-pricing-components.pages.dev/'

export const getPricingIframeUrl = () => PRICING_IFRAME_URL

/**
 * Assign or unassign a workspace license to/from a project.
 * @param {'assign'|'unassign'} action - Whether to assign or unassign
 * @param {string} licenseType - The license/plan type (e.g. 'Agency')
 * @param {string} project - The project uniqueUrl
 * @returns {Promise<object>}
 */
export const changeLicense = async ({ action, licenseType, project }) => {
  const res = await fetch(`${API_BETA}guest/web-builder/change-license`, {
    method: 'POST',
    headers: jsonHeadersWithToken(),
    body: JSON.stringify({
      action,
      licenseType,
      project,
      source: 'workspace',
    }),
  })

  const data = await res.json().catch(() => null)

  if (!res.ok) {
    const message = data?.error || data?.message || `Failed to ${action} license`
    throw new Error(message)
  }

  return data
}
